import React from "react";
import {Col, Image} from "react-bootstrap";
import SectionContainer from "../../components/SectionContainer";
import AboutBlocks from "./AboutBlocks";
import AboutSponsor from "./AboutSponsor";
// import {AiOutlineCheckCircle} from "react-icons/ai";
import {RowReversedStyled} from "./About.styled";
// import {paragraphs} from "./aboutData";
import aboutImage from "../../assets/ww.jpg";
import boutImage from "../../assets/qq.jpg";
import vedio from "../../assets/videos/Thedisruptlabs.mp4";
import ImageSlid from './ImageSlid';
import ImageSlide from './ImageSlide';
const About = () => {
  return (
    <>
      <SectionContainer id={"about"} secName={"about-sec"}>
        <RowReversedStyled className="my-2">
          {/* <Col lg={6} className="mb-3">
            <h3>
              Voluptatem dignissimos provident quasi corporis voluptates sit
              assumenda.
            </h3>
            <p className="fst-italic">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <ul>
              {paragraphs.map((par, idx) => (
                <li className="mb-3" key={idx}>
                  <AiOutlineCheckCircle
                    className="me-1"
                    size={24}
                    color={"var(--ds-blood)"}
                  />
                  {par}
                </li>
              ))}
            </ul>
            <p>
              Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
              irure dolor in reprehenderit in voluptate velit esse cillum dolore
              eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
              proident, sunt in culpa qui officia deserunt mollit anim id est
              laborum
            </p>
          </Col> */}
          {/* <Col lg={6} className="mb-3">
            <Image
              src={aboutImage}
              alt="about-img"
              width="100%"
              height="auto"
            />
          </Col> */}
          <div class="row justify-content-between" id="about-container">
          <div class="col-lg-6 order-lg-1 mb-3">

    <div class="video-container">
      <div class="video-thumbnail" id="thumbnail"></div>

      <video
        controls
        autoplay
        muted
        class="w-100 shadow-lg rounded video"
        id="video"
        width="50%"
        height="auto"
      >
        <source
          src={vedio}
          type="video/mp4"
        />

        Download the
        <a href={vedio}>WEBM</a>
        or
        <a href={vedio}>MP4</a>
        video.
      </video>
    </div>
    <div class="d-flex">
      <i class="bi bi-play-circle-fill video-title-icon"></i>
      <p class="about-video-title">Watch How NajamTech AI Works</p>
    </div>
  </div>

  <div class="col-lg-5 align-self-center about-text-div">
    <h1 class="headers my-3">About Us</h1>
    <div class="w-100">
      <p class="about-para"style={{ fontFamily: "Arial", fontSize: "18px" }}>
      NajamTech AI specializes in AI-based solutions for various industries, with expertise in object detection, recognition, and inspection. They help manufacturing companies, warehouses, and outdoor sites enhance visual inspection, safety, security, and efficiency by integrating AI technology to visual sensors like CCTV and machine vision cameras. They also offer website design, 3D modeling services. With a commitment to delivering high-quality and innovative solutions, NajamTech AI is a reliable partner for businesses seeking to enhance operations with cutting-edge technology.
      </p>
    </div>
  </div>
</div>
<ImageSlid/> 
      <ImageSlide />
          {/* <div class="row justify-content-between" id="about-container">
  <div class="col-lg-6 order-lg-2 mb-5 mt-5">
    <div class="video-container">
      <div class="video-thumbnail" id="thumbnail"></div>

      <video
        controls
        autoplay
        muted
        class="w-100 shadow-lg rounded video"
        id="video"
        width="100%"
        height="auto"
      >
        <source
          src={vedio}
          type="video/mp4"
        />

        Download the
        <a href={vedio}>WEBM</a>
        or
        <a href={vedio}>MP4</a>
        video.
      </video>
    </div>
    <div class="d-flex">
      <i class="bi bi-play-circle-fill video-title-icon"></i>
      <p class="about-video-title">Watch How NajamTachno Works</p>
    </div>
  </div>

  <div class="col-lg-6 align-self-center about-text-div">
    <h1 class="headers my-3">About Us</h1>
    <div class="w-100">
      <h5 class="about-para">
      Najamtech AI specializes in AI-based solutions for various industries, with expertise in object detection, recognition, and inspection. They help manufacturing companies, warehouses, and outdoor sites enhance visual inspection, safety, security, and efficiency by integrating AI technology to visual sensors like CCTV and machine vision cameras. They also offer website design, 3D modeling services. With a commitment to delivering high-quality and innovative solutions, Najamtech AI is a reliable partner for businesses seeking to enhance operations with cutting-edge technology.
      </h5>
    </div>
  </div>
</div> */}

    

        </RowReversedStyled>
        <AboutBlocks />
        <div className="row justify-content-between py-5" id="about-container" style={{ position: "relative", zIndex: "2" }}>
  <Col lg={6} className="mb-3">
    <Image
      src={aboutImage}
      alt="about-img"
      width="100%"
      height="auto"
      className="image-with-shadow"
    />
  </Col>
  
  <div className="col-lg-5 align-self-center about-text-div">
    <h1 className="headers my-3">Solutions for efficient warehouse management</h1>
    <div className="w-100">
      <p className="about-para" style={{ fontFamily: "Arial", fontSize: "18px" }}>
        We provide cutting-edge AI-based solutions for efficient warehouse management. With its advanced detection and inspection software, businesses can ensure accurate tracking of inventory, reducing errors and improving productivity. The software's intelligent algorithms enable businesses to identify potential issues and take proactive measures to mitigate them, enhancing overall operational efficiency. NajamTech AI's AI-powered warehouse management solutions are a game-changer for businesses looking to optimize their operations and stay ahead of the competition.
      </p>
    </div>
  </div>
</div>

<div class="row justify-content-between py-5" id="about-container" style={{ position: "relative", zIndex: "2" }}>
  <div class="col-lg-5 align-self-center about-text-div">
    <h1 class="headers my-3">Cutting-edge solutions</h1>
    <div class="w-100">
      <p class="about-para" style={{ fontFamily: "Arial", fontSize: "18px" }}>
        NajamTech AI is leveraging the power of AI to provide cutting-edge solutions for warehouse management. Their advanced detection and inspection software enables businesses to automate their inventory management, improve accuracy, and reduce operational costs. With real-time data insights, businesses can make informed decisions and optimize their warehouse operations for maximum efficiency. NajamTech AI's AI-based software is a game-changer for businesses looking to stay competitive in today's fast-paced market.
      </p>
    </div>
  </div>
  <div class="col-lg-6 order-lg-1 mb-3">
    <Image
      src={boutImage}
      alt="about-img"
      width="100%"
      height="auto"
    />
  </div>
</div>






      </SectionContainer>
      
  
      {/* <ImageSlid /> 
      <ImageSlide /> */}
      {/* <AboutSponsor /> */}
    </>
  );
};

export default About;
